import './scss/style.scss';
import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;


require('./scss/vendor/owl.carousel.css');
require('./scss/vendor/owl.theme.default.css');
require('./scss/simple-calendar.css');

require('./openweather/openweather.js');
require('./js/slick.min.js');
require('./js/jquery.fancybox.min.js');
require('./js/gmap.js');
require('./js/script.js');
require('./js/script-masonry.js');
require('./js/owl.carousel.js');
require('./js/jquery.simple-calendar.js'); 
